import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { styles } from '../../styles';

type UploadStyleProps = { isDragging: boolean };

const containerStyles = () => css`
  display: flex;
  flex-flow: column;
  width: 100%;
`;

const boxStyles = ({ isDragging }: UploadStyleProps) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border-radius: ${theme.borderRadius.small};
  border: ${isDragging ? 'solid' : 'dashed'} ${!isDragging ? theme.colors.neutral30 : theme.colors.primary50} 1px;
  background-color: ${theme.colors.neutral5};
  cursor: pointer;
  padding: ${theme.spacing(2)};
  font-size: 14px;
  margin-bottom: ${theme.spacing(2)};
`;

const iconStyles = css`
  transform: rotate(90deg);
`;

const buttonStyles = css`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  word-wrap: none;
  width: max-content;
  padding: ${theme.spacing(1.25, 2)};
  border: 1px solid ${theme.colors.neutral50};
  box-sizing: border-box;
  border-radius: ${theme.spacing(0.5)};
  margin-top: ${theme.spacing(2.5)};
  cursor: pointer;
`;

const imagePreviewContainerStyles = css`
  display: flex;
  flex-flow: row wrap;
  padding-bottom: ${theme.spacing(1.5)};
`;

const imagePreviewStyles = css`
  display: flex;
  flex-flow: column;
  align-content: center;
  max-width: 100px;
  margin-left: ${theme.spacing(3)};
`;

const imagePreviewTextStyles = css`
  height: 100%;
  ${styles.truncate}
  flex:auto;
`;

const errorTextStyles = css`
  color: ${theme.colors.text.critical};
`;

export const FileUploadStyles = {
  container: containerStyles(),
  box: (props: UploadStyleProps) => boxStyles(props),
  iconTranslate: iconStyles,
  button: buttonStyles,
  imagePreviewContainer: imagePreviewContainerStyles,
  imagePreview: imagePreviewStyles,
  imagePreviewText: imagePreviewTextStyles,
  errorText: errorTextStyles,
};
